const doc = [({"da":({"js":({"admin":({"contacts":({"link":({"no_contact":"Ingen kontakt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;